import { Component, output, input } from '@angular/core';

@Component({
  selector: 'app-close-button',
  imports: [],
  templateUrl: './close-button.component.html',
  styleUrl: './close-button.component.scss',
})
export class CloseButtonComponent {
  // Output event when button is clicked
  closeClick = output<void>();

  // Optional title for accessibility
  title = input<string>('Close');

  onClose(): void {
    this.closeClick.emit();
  }
}
